export default "__VITE_ASSET__BHeC7KOB__"